import tw from 'twin.macro'

export const PrimaryLink = tw.a`cursor-pointer font-bold text-primary-500 border-b-2 border-transparent hocus:border-primary-500 hocus:text-primary-800 transition duration-300`

export const BlackUnderlineLink = tw.a`cursor-pointer border-text-dark border-b-2 hocus:border-primary-500 hocus:text-primary-500 transition duration-300`